import React from 'react';
import ShareRewindSlideBase from './ShareRewindSlideBase';
import { RewindStats } from '../../utils/rewindStats';

interface ShareRewindFirstTimePortsSlideProps {
  year: number;
  stats: RewindStats;
}

const ShareRewindFirstTimePortsSlide = React.forwardRef<HTMLDivElement, ShareRewindFirstTimePortsSlideProps>(
  ({ year, stats }, ref) => {
    if (stats.firstTimePorts.length === 0) {
      return null;
    }

    // Determine grid layout and sizing based on number of ports
    const portCount = stats.firstTimePorts.length;
    let gridCols = 3;
    let fontSize = 'text-4xl';
    let padding = 'p-6';
    let maxDisplay = 12;
    
    if (portCount <= 3) {
      gridCols = 1;
      fontSize = 'text-6xl';
      padding = 'p-8';
      maxDisplay = 3;
    } else if (portCount <= 6) {
      gridCols = 2;
      fontSize = 'text-5xl';
      padding = 'p-7';
      maxDisplay = 6;
    } else if (portCount <= 9) {
      gridCols = 3;
      fontSize = 'text-4xl';
      padding = 'p-6';
      maxDisplay = 9;
    } else {
      gridCols = 3;
      fontSize = 'text-3xl';
      padding = 'p-5';
      maxDisplay = 12;
    }

    const displayPorts = stats.firstTimePorts.slice(0, maxDisplay);

    return (
      <ShareRewindSlideBase ref={ref} year={year}>
        <div className="flex flex-col h-full">
          {/* Top Section - Title */}
          <div className="flex flex-col items-center justify-center text-center pt-20 pb-8">
            <div className="text-7xl font-bold text-white leading-none mb-4">
              First Time Ports
            </div>
            <div className="text-5xl text-white/90 font-medium">
              {stats.firstTimePorts.length} {stats.firstTimePorts.length === 1 ? 'Port' : 'Ports'} Visited for the First Time
            </div>
          </div>

          {/* Middle Section - Ports Grid */}
          <div className="flex-1 flex items-center justify-center px-8">
            <div className={`grid gap-6 w-full max-w-5xl ${
              gridCols === 1 ? 'grid-cols-1' : 
              gridCols === 2 ? 'grid-cols-2' : 
              'grid-cols-3'
            }`}>
              {displayPorts.map((port, index) => (
                <div
                  key={index}
                  className={`bg-white/10 backdrop-blur-sm rounded-lg ${padding} text-center`}
                >
                  <div className={`${fontSize} font-bold text-white leading-tight`}>
                    {port}
                  </div>
                </div>
              ))}
            </div>
            {stats.firstTimePorts.length > maxDisplay && (
              <div className="text-4xl text-white/90 mt-4">
                +{stats.firstTimePorts.length - maxDisplay} more
              </div>
            )}
          </div>

          {/* Bottom Section - Branding */}
          <div className="flex flex-col items-center text-center pb-12">
            <div className="text-4xl font-bold text-white leading-none mb-2">
              Cruising Along Rewind {year}
            </div>
          </div>
        </div>
      </ShareRewindSlideBase>
    );
  }
);

ShareRewindFirstTimePortsSlide.displayName = 'ShareRewindFirstTimePortsSlide';

export default ShareRewindFirstTimePortsSlide;

